import axiosInstance from './axiosInstance';

const tagService = {
  getTags: async (params = {}) => {
    const response = await axiosInstance.get('/questions/tags', { params });
    return response.data;
  },

  createTag: async (data) => {
    const response = await axiosInstance.post('/questions/tags', data);
    return response.data;
  },

  updateTag: async (id, data) => {
    const response = await axiosInstance.put(`/questions/tags/${id}`, data);
    return response.data;
  },

  deleteTag: async (id) => {
    const response = await axiosInstance.delete(`/questions/tags/${id}`);
    return response.data;
  },
};

export default tagService; 